import { Box, Typography } from '@mui/material'
import React from 'react'

const ValueProposition = () => {
  return (
    <Box id = 'valueProposition' sx={{marginTop: '6rem', textAlign: 'center', fontWeight: 'bold', paddingTop: '5rem', paddingBottom: '3rem'}}>

        <Box sx={{marginTop: '2rem', backgroundColor: '#D9D9D9', padding: '2rem'}}>

            <Typography sx={{fontSize: '3rem', borderRadius: '10px', marginBottom: '1rem',
                                        '@media (max-with: 442px)': {fontSize: '1.5rem'}}}> 
                            Value Proposition
            </Typography>

            <Typography variant='h5' sx={{fontWeight : 'bold', marginBottom: '1rem'}}>
                Predictive Analytics:
            </Typography>
            <Typography sx={{fontSize: '1.1rem', color: '#000000', marginBottom: '1rem'}}>
                Critical strategy work around resource planning, product planning and much more, relies heavily on predictive analytics. Time series forecasting is a type of predictive analytics that finds application in such kind of critical strategy work. Predictive analytics is used to determine unknown outcome based on known information and data. Time series forecasting captures past information contained in historical data then uses this information to predict future information. There are several examples across industries.  In supply chain, predicting customer demand for product planning. In healthcare,  predicting patient traffic across a network of ER’s to determine optimal medical personnel staffing across a healthcare system.  Predictive analytics uses statistical and machine learning algorithms. Check out the time series forecaster in the Featured Products section.


            </Typography>
            
            <Typography variant='h5' sx={{fontWeight : 'bold', marginBottom: '1rem'}}>
                Scenario Simulation:
            </Typography>
            <Typography sx={{fontSize: '1.1rem', color: '#000000', marginBottom: '1rem'}}>
                Simulation serves the main purpose of seeking and validating solutions to real world problems. Discrete event simulation is a type of simulation that is used to model how a process behaves over time by representing it as a series of sequential events. Even though there are numerous specialized simulation software, there is a lot of opportunity to be creative and minimize simulation costs by using the ever-evolving state-of-the-art data technologies; and use them to structure and simulate certain processes. Check out the inventory policy simulator that is in the Featured Products section. It is a discrete event simulation model written in python programming language.


            </Typography>
                        
            <Typography variant='h5' sx={{fontWeight : 'bold', marginBottom: '1rem'}}>
                Performance Monitoring:
            </Typography>
            <Typography sx={{fontSize: '1.1rem', color: '#000000', marginBottom: '1rem'}}>
                The continuous assessment of a system to ensure that it's operating normally is a critical aspect of operations excellence. It entails detecting and responding to any deviations from normalcy. Realtime analytics has the capability of taking Statistical Process Control (SPC) to the next level of value. Real-time or near real-time actionable insight will have significant benefits around maintaining operations excellence. There are several examples. Monitoring medical errors over time in healthcare. Monitoring the performance of fraud detection algorithms in banking. Monitoring call center response time in customer service departments across all industries. 
  
            </Typography>
                       
            <Typography variant='h5' sx={{fontWeight : 'bold', marginBottom: '1rem'}}>
                Data Models and Automation:
            </Typography>
            <Typography sx={{fontSize: '1.1rem', color: '#000000', marginBottom: '1rem'}}>
                Reducing or eliminating human intervention in repetitive, time-consuming analytics tasks. This comes with the advantage of freeing up people resources so that they get involved in solving real problems and hence creating real value to businesses. Automation done right will improve efficiency, reduce costs and ultimately improve bottom line.

 
            </Typography>
                                   
            <Typography variant='h5' sx={{fontWeight : 'bold', marginBottom: '1rem'}}>
                Research and Proof Of Concept (POC):
            </Typography>
            <Typography sx={{fontSize: '1.1rem', color: '#000000', marginBottom: '1rem'}}>
                One of the first steps in every innovation endeavor. You have a concept that you want to test or refine before committing to full development. You want to do this in an efficient and cost-effective manner. POC will help you with making better decisions based on real data, reducing development risks and building stakeholder confidence.

            </Typography>




        </Box>
 
    </Box>
  )
}

export default ValueProposition


